// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{font-display:swap}#game_box{position:relative;width:100%;height:100%}#logo{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
